var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('autocomplete',{ref:"autocomplete",attrs:{"source":_vm.suggestions,"disableInput":_vm.disabled,"resultsValue":"name","inputClass":"invites-autocomplete","placeholder":"Enter invitee name"},on:{"selected":_vm.handleSelected}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-559dabf8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Booking/Invites/Autocomplete.vue
// module id = null
// module chunks = 